import { usePathname, useRouter } from '@/i18n/navigation'
import { isStaticRoute } from '@/i18n/utils'
import type { Locale } from '@/shared/locale'
import { routes } from '@/shared/routes'
import { useGlobalStore } from '@/shared/store/provider'

export const useHandleLanguageChange = () => {
  const router = useRouter()
  const pathname = usePathname()
  const { _slugs, _pageCustomerType } = useGlobalStore((state) => state.system)

  const handleLanguageChange = (locale: Locale) => {
    const isEnterprise = _pageCustomerType === 'enterprise'

    if (isStaticRoute(pathname)) {
      router.push(pathname, { locale })
      return
    }

    if (!_slugs[locale]?.length) {
      router.push(isEnterprise ? routes.ENTERPRISE_HOME : routes.HOME, { locale })
      return
    }

    if (pathname === routes.QUIZ) {
      router.push({ pathname: routes.QUIZ, params: { slug: _slugs[locale][0] } }, { locale })
      return
    }

    if (pathname === routes.BLOG_ARTICLE || pathname === routes.ENTERPRISE_BLOG_ARTICLE) {
      router.push(
        {
          pathname: isEnterprise ? routes.ENTERPRISE_BLOG_ARTICLE : routes.BLOG_ARTICLE,
          params: { slug: _slugs[locale][0] },
        },
        { locale },
      )
      return
    }

    if (pathname === routes.BLOG_CATEGORY || pathname === routes.ENTERPRISE_BLOG_CATEGORY) {
      router.push({ pathname: isEnterprise ? routes.ENTERPRISE_BLOG : routes.BLOG }, { locale })
      return
    }

    if (pathname === routes.GENERIC || pathname === routes.ENTERPRISE_GENERIC) {
      router.push(
        {
          pathname: isEnterprise ? routes.ENTERPRISE_GENERIC : routes.GENERIC,
          params: { slug: _slugs[locale] },
        },
        { locale },
      )
      return
    }
  }

  return handleLanguageChange
}
